

import React, { useState, useEffect } from 'react';
import GMap from './GMap';

const App = () => {
  const [loadMap, setLoadMap] = useState(false);

  // useEffect(() => {
  //   loadGoogleMapScript(() => {
  //     setLoadMap(true)
  //   });
  // }, []);

  return (
    <GMap  />
    // <div className="App">
    //   {!loadMap ? <div>Loading...</div> : <GMap />}
  
    // </div>
  );
}

export default App;
